import { ResourceContainer } from 'ohzi-core';
import { SceneManager } from 'ohzi-core';
import { Time } from 'ohzi-core';
import FloorLight from './FloorLight';

export default class FloorManager
{
  constructor()
  {
    this.floor_lights = [];
    // this.t = 0;
  }

  start()
  {
    // this.__init_floor_lights('floor_light', this.floor_lights, 20);
    // this.__init_floor_lights('floor_light_rose', this.floor_lights, 20);
  }

  update()
  {
    for (let i = 0; i < this.floor_lights.length; i++)
    {
      const floor_light = this.floor_lights[i];
      floor_light.update();
    }

    // if (this.t > 1) {

    // }

    this.t += Time.delta_time;
  }

  __init_floor_lights(floor_light_name, floor_lights, amount)
  {
    let current_z_position = 100;
    for (let i = 0; i < amount; i++)
    {
      let floor_light = ResourceContainer.get_resource(floor_light_name).scene.children[0].clone();

      SceneManager.current.add(floor_light);
      floor_light.material.transparent = true;
      floor_light.material.opacity = 0.3;

      floor_light.position.set(
        Math.floor(Math.random() * 100) - 50,
        Math.floor(Math.random() * 100) - 50,
        current_z_position += 60); // current_z_position += 20
      floor_lights.push(new FloorLight(floor_light));
    }
  }
}
